export const getNow = (maxDate?: Date) => {
  const now = new Date();

  // If maxDate is provided and now is after maxDate, return maxDate instead
  if (maxDate && now > maxDate) {
    return maxDate;
  }

  return now;
};
